WiseMetering.Views.AlarmSchedule = WiseMetering.Views.BaseSchedule.extend({
    colors: WiseMetering.Colors.AlarmTemplates,
    template: 'templates/ui/schedule/alarm_schedule'
});
